import yup from 'yup'
import { precision } from '@atheneum/api/dist/lib'

const account = yup.object().shape({
  id: yup
    .number()
    .required('Account field is required')
    .typeError('Account field is required')
})

const project = yup.object().shape({
  id: yup
    .number()
    .required('Account field is required')
    .typeError('Account field is required')
})

export default yup.object().shape({
  parentAccount: yup
    .object()
    .typeError(
      'Parent account field is required, select one of the suggested items'
    )
    .shape({
      id: yup
        .number()
        .typeError(
          'Parent account field is required, select one of the suggested items'
        )
    }),
  clientContact: yup
    .object()
    .nullable()
    .typeError(
      'Client key contact field is required, select one of the suggested items'
    )
    .shape({
      id: yup
        .number()
        .nullable()
        .typeError(
          'Client key contact field is required, select one of the suggested items'
        )
    }),
  employeeContact: yup
    .object()
    .typeError('Signed by field is required, select one of the suggested items')
    .shape({
      id: yup
        .number()
        .typeError(
          'Signed by field is required, select one of the suggested items'
        )
    }),
  contractCoverageId: yup
    .number()
    .typeError(
      'Contract coverage field is required, select one of the suggested items'
    ),
  accounts: yup.array().when('contractCoverageId', {
    is: 2,
    then: yup.array().of(account.typeError('Account field is required'))
  }),
  projects: yup.array().when('contractCoverageId', {
    is: 3,
    then: yup.array().of(project.typeError('Project field is required'))
  }),
  contractTypeId: yup
    .number()
    .typeError(
      'Contract type field is required, select one of the suggested items'
    ),
  contractTypeDetailId: yup
    .number()
    .typeError(
      'Contract type field is required, select one of the suggested items'
    ),
  signed: yup.boolean(),
  rangeMin: yup
    .number()
    .min(0)
    .when('contractTypeId', {
      is: 1,
      then: yup
        .number()
        .required('Price from field is required')
        .typeError('Price from must be a number')
        .test(
          'two-decimal-places',
          'Number can contain only 2 decimal places. (e.g. 33.20)',
          precision(2)
        ),
      otherwise: yup.number().nullable()
    })
    .typeError('Price from must be a number'),
  rangeMax: yup
    .number()
    .min(0)
    .when('contractTypeId', {
      is: 1,
      then: yup
        .number()
        .required('Price to field is required')
        .typeError('Price to must be a number')
        .test(
          'two-decimal-places',
          'Number can contain only 2 decimal places. (e.g. 33.20)',
          precision(2)
        ),
      otherwise: yup.number().nullable()
    }),
  startDate: yup
    .date()
    .required('Start date is required')
    .nullable(),
  endDate: yup
    .date()
    .required('End date is required')
    .nullable(),
  unlimited: yup.boolean().nullable(),
  value: yup
    .number()
    .when('unlimited', {
      is: true,
      then: yup.number().nullable()
    })
    .when('contractTypeId', {
      is: 1,
      then: yup
        .number()
        .moreThan(0, `Value can't be 0`)
        .typeError('Value field must be a number')
        .test(
          'two-decimal-places',
          'Value can contain only 2 decimal places. (e.g. 33.20)',
          precision(2)
        ),
      otherwise: yup.number().nullable()
    })
    .when('contractBalance', {
      is: contractBalance => contractBalance < 0,
      then: yup
        .number()
        .test(
          'always-false',
          'Negative contract balance, increase total value',
          () => false
        )
    }),
  creditAmount: yup
    .number()
    .when('contractTypeId', {
      is: 1,
      then: yup.number().nullable(),
      otherwise: yup
        .number()
        .required('Credits field is required')
        .typeError('Credits field must be a number')
        .test(
          'two-decimal-places',
          'Number can contain only 2 decimal places. (e.g. 33.20)',
          precision(2)
        )
    })
    .when('contractBalance', {
      is: contractBalance => contractBalance < 0,
      then: yup
        .number()
        .test(
          'always-false',
          'Negative contract balance, add more credits',
          () => false
        )
    }),
  creditValue: yup.number().when('contractTypeId', {
    is: 1,
    then: yup.number().nullable(),
    otherwise: yup
      .number()
      .required('Credit value field is required')
      .typeError('Credit value field must be a number')
      .test(
        'two-decimal-places',
        'Number can contain only 2 decimal places. (e.g. 33.20)',
        precision(2)
      )
  }),
  currencyId: yup
    .number()
    .typeError('Currency field is required, select one of the suggested items'),
  contractBalance: yup.number()
})
